<template>
  <!-- 页面右侧头部 -->
  <div class="dy-flex jy-c-sb" style="width: 100%">
    <!-- 标头 -->
    <div class="title dy-flex">
      <div class="dy-flex align-i-c">
        <div class="dy-flex align-i-c">
          <img src="/img/images/logo_szht2.png" width="147px" height="35px" />
        </div>
      </div>
      <div class="">
        <div class="logo">
          <div class="sysName">智慧财务网上综合服务平台</div>
          <div class="sysNameE">
            Financial Online Integrated Service Platform
          </div>
        </div>
      </div>
    </div>
    <!-- 中英文切换 -->
    <Languageqh v-if="$store.state.sysCs.sfqy_zywqh == '1'"></Languageqh>
  </div>
</template>

<script>
import pathToRegexp from "path-to-regexp";
import Languageqh from "@/components/Languageqh.vue";

export default {
  name: "frameHeader",
  components: {
    Languageqh
  },
  computed: {
    username() {
      return this.$store.state.userName;
    },
    text() {
      return {
        id: this.number,
        val: this.arr[this.number],
      };
    },
    isShowLanguage() {
      return this.$store.state.sysCs.isShowLanguage;
    },
  },
  data() {
    return {
      levelList: [],
      iconClass: "el-icon-s-fold",
      circleUrl: "/img/profile.png",
      size: "medium",
    };
  },
  methods: {
    getBreadcrumb() {
      this.levelList = [];
      // only show routes with meta.title
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      if (matched.length == 2 && matched[1].path == "/zl/tjtb") {
        matched = [matched[1]];
      }

      let first = matched[0];

      if (!this.isDashboard(first) && first.path != "/zl/tjtb") {
        matched = [
          {
            path: "/zl/tjtb",
            meta: { title: { zh: "总览", en: "dashboard" } },
          },
        ].concat(matched);
      }

      this.levelList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
    },
    isDashboard(route) {
      let path = route && route.path;

      if (!path) {
        return false;
      }
      return path.trim().toLocaleLowerCase() === "/zl/tjtb".toLocaleLowerCase();
    },
    pathCompile(path) {
      let { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
      const { redirect, path } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      if (redirect === null) {
        // this.$router.push(redirect)
        // this.$root.$emit("breadcrumbEmit", path); // 组件传值
        return;
      }
      if (redirect === undefined) {
        this.$router.push(this.pathCompile(path));
        return;
      }
    },
    exit() {
      this.$requestUtil.logout();
    },
    goto() {
      // 菜单路由跳转
      this.$router
        .push({ path: JSON.parse(this.$session.getItem("firstTag")).path })
        .catch((err) => {
          err;
        });
    },
  },
  mounted() {
    if (!this.$store.state.userName) {
      this.$store.commit("setUserName", this.$session.getItem("userName"));
    }
    $(".el-dropdown").css(
      "color",
      JSON.parse(this.$session.getItem("sysCs"))
        ? JSON.parse(this.$session.getItem("sysCs")).menubgcolor
        : ""
    );
    $(".header-right").css(
      "color",
      JSON.parse(this.$session.getItem("sysCs"))
        ? JSON.parse(this.$session.getItem("sysCs")).menubgcolor
        : ""
    );
  },
  created() {
    this.getBreadcrumb();
  },
  watch: {
    $route(val) {
      this.getBreadcrumb();
    },
    "$i18n.locale"(val) {
      this.getBreadcrumb();
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding: 25px 0 25px 0;
  background-image: url(/img/images/logo_bg.png);
  background-position: left top;
  background-repeat: no-repeat;
}
.logo {
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #ddd;
  .sysName {
    color: #0066b1;
    font-size: 18px;
  }
  .sysNameE {
    color: #999;
    font-size: 14px;
  }
}
.el-dropdown-link {
  display: flex;
  align-items: center;
  span,
  label,
  i {
    cursor: pointer;
  }
}
.nameClass {
  margin-left: 10px;
}
</style>
